module.exports = __webpack_public_path__ + "media/images/frontend/greater-5ee97d021d88216e1ab886e60492e5f8.svg";